import { Link, useLocation } from 'react-router-dom'
import { User } from 'lucide-react'
import { LanguageSelector } from './LanguageSelector'
import { InstallButton } from './InstallButton'

interface NavbarProps {
    centerContent?: React.ReactNode
    className?: string
    onHelpClick?: () => void
    onDebugClick?: () => void
    showInstallButton?: boolean
}

export function Navbar({ centerContent, className = '', onHelpClick, onDebugClick, showInstallButton = true }: NavbarProps) {
    const location = useLocation()
    return (
        <header className={`px-4 py-3 border-b border-zinc-800 bg-zinc-900/90 backdrop-blur-md sticky top-0 z-50 ${className}`}>
            <div className="max-w-4xl mx-auto flex items-center justify-between">
                <Link to="/" className="text-xl font-bold text-white flex items-center gap-2">
                    <img src="/logo-handpainted-512.png" alt="Logo" className="w-8 h-8" />
                    <span><span className="text-brand-red">Blaze</span> Grids</span>
                </Link>

                {location.pathname !== '/' && (
                    <div className="hidden md:flex items-center ml-6 border-l border-zinc-700 pl-6 h-8">
                        <Link to="/" className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">
                            Back to Home
                        </Link>
                    </div>
                )}

                {centerContent && (
                    <div className="flex-1 flex justify-center">
                        {centerContent}
                    </div>
                )}

                <div className="flex items-center gap-3">
                    {showInstallButton && <InstallButton onDebugClick={onDebugClick} />}
                    <LanguageSelector />

                    <Link
                        to="/account"
                        className="w-9 h-9 flex items-center justify-center rounded-lg bg-zinc-800/50 hover:bg-zinc-700 text-zinc-300 hover:text-white transition-colors border border-zinc-700"
                        aria-label="Account"
                    >
                        <User size={18} />
                    </Link>

                    {onHelpClick ? (
                        <button
                            onClick={onHelpClick}
                            className="w-9 h-9 flex items-center justify-center rounded-lg bg-zinc-800/50 hover:bg-zinc-700 text-zinc-300 hover:text-white transition-colors border border-zinc-700 font-bold"
                            aria-label="Help"
                        >
                            ?
                        </button>
                    ) : (
                        <Link
                            to="/help"
                            className="w-9 h-9 flex items-center justify-center rounded-lg bg-zinc-800/50 hover:bg-zinc-700 text-zinc-300 hover:text-white transition-colors border border-zinc-700 font-bold"
                            aria-label="Help"
                        >
                            ?
                        </Link>
                    )}
                </div>
            </div>
        </header>
    )
}
